'use es6';

import UrlParts from './parts/UrlParts';
const DOMAIN_REGEX = new RegExp(`^${UrlParts.domain}$`, 'i');
export default DOMAIN_REGEX;